import { render, staticRenderFns } from "./TablaHallazgosAdicionales.vue?vue&type=template&id=66731aea&scoped=true"
import script from "./TablaHallazgosAdicionales.vue?vue&type=script&lang=js"
export * from "./TablaHallazgosAdicionales.vue?vue&type=script&lang=js"
import style0 from "./TablaHallazgosAdicionales.vue?vue&type=style&index=0&id=66731aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66731aea",
  null
  
)

export default component.exports